import { render, staticRenderFns } from "./CandidatesDirectory.vue?vue&type=template&id=29d0dd37&scoped=true&"
import script from "./CandidatesDirectory.vue?vue&type=script&lang=js&"
export * from "./CandidatesDirectory.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesDirectory.vue?vue&type=style&index=0&id=29d0dd37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d0dd37",
  null
  
)

export default component.exports